import { combineReducers, configureStore } from '@reduxjs/toolkit';
import authSlice from '@services/auth/authSlice';
import surveySlice from '@services/survey/surveySlice';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { surveyApi } from '@services/survey/surveyApi';
import { authApi } from '@services/auth/authApi';
import { responseSlice } from '@services/response/responseSlice';
import resultSlice from '@services/result/resultSlice';
import shareSlice from '@services/share/shareSlice';

const rootReducer = combineReducers({
  auth: authSlice.reducer,
  authApi: authApi.reducer,
  survey: surveySlice.reducer,
  surveyApi: surveyApi.reducer,
  response: responseSlice.reducer,
  result: resultSlice.reducer,
  share: shareSlice.reducer,
});

export const store = configureStore({
  reducer: rootReducer,
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .concat(surveyApi.middleware)
      .concat(authApi.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default store;
